// function hideAltliWithoutHiddenInput() {
//     // Select all .product-grid-options-color elements
//     const colorOptions = document.querySelectorAll('.product-grid-options-color');
  
//     colorOptions.forEach(option => {
//       // Select all .altli elements within the .product-grid-options-color
//       const altliElements = option.querySelectorAll('.altli');
  
//       altliElements.forEach(altli => {
//         // Check if there's an input of type="hidden" with a value within .altli
//         const hiddenInput = altli.querySelector('input[type="hidden"][value]');
        
//         // If no such input is found, hide the .altli element
//         if (!hiddenInput) {
//           altli.style.display = 'none';
//         }
//       });
//     });
//   }
  
//   // Call the function to apply the changes
//   hideAltliWithoutHiddenInput();
  
//   document.querySelectorAll('.product-grid-options-size .altli').forEach(div => {
//     // Check if the div does NOT have both "is-selected" and "ava" classes
//     if (!div.classList.contains('is-selected')) {
//       // Hide the div if it doesn't have both classes
//       div.style.display = 'none';
//     }
//   });
  
//     const parentDiv = document.querySelector('.product-group-variants');


// function updateSelectedSize(event) {
//     // Get the clicked radio button (color) and its parent .product-group-variants
//     const selectedColor = event.target;
//     const productGroupVariants = selectedColor.closest('.product-group-variants');

//     if (!productGroupVariants) {
//         console.error("No parent .product-group-variants found.");
//         return;
//     }

//     const selectedColorValue = selectedColor.value;

//     // Find the .product-grid-options-size within the same .product-group-variants
//     const sizeOptionsContainer = productGroupVariants.querySelector('.product-grid-options-size');

//     if (!sizeOptionsContainer) {
//         console.error("No size options container found within the same parent.");
//         return;
//     }

//     // Iterate through the size options to find a matching size-val
//     const sizeVals = sizeOptionsContainer.querySelectorAll('.size-val');
//     let matchFound = false;

//     sizeVals.forEach((sizeVal) => {
//         const parentDiv = sizeVal.closest('.altli'); // Parent .altli
//         if (parentDiv) {
//             if (sizeVal.id === selectedColorValue) {
//                 // Add the new class to the parent div if it matches
//                 parentDiv.classList.add('is-selected');
//                 parentDiv.classList.add('new');
//                 parentDiv.style.display = 'block';
//                 matchFound = true;
//             } else {
//                 // Remove the class if it doesn't match
//                 parentDiv.classList.remove('is-selected');
//                 parentDiv.classList.remove('new');
//                 parentDiv.style.display = 'none';
//             }
//         }
//     });

//     if (!matchFound) {
//         console.warn(`No matching size found for the selected color: ${selectedColorValue}`);
//     }
// }

// // Attach event listeners to color radio buttons for each .product-group-variants
// document.querySelectorAll('.product-group-variants').forEach((productGroup) => {
//     const colorRadios = productGroup.querySelectorAll('.product-grid-options-color input[type="radio"]');
//     colorRadios.forEach((radio) => {
//         radio.addEventListener('change', updateSelectedSize);
//     });
// });

// // Initial state update for all .product-group-variants
// document.querySelectorAll('.product-group-variants').forEach((productGroup) => {
//     const selectedRadio = productGroup.querySelector('.product-grid-options-color input[type="radio"]:checked');
//     if (selectedRadio) {
//         updateSelectedSize({ target: selectedRadio });
//     }
// });


// function removeDuplicateSizes() {
//   // Select all `product-grid-options-size` containers
//   const sizeContainers = document.querySelectorAll('.product-grid-options-size');

//   sizeContainers.forEach((sizeContainer) => {
//       // Step 1: Get all `altli` divs inside the container
//       const altliDivs = sizeContainer.querySelectorAll('.altli');

//       // Step 2: Use a Map to track unique values
//       const sizeMap = new Map();

//       altliDivs.forEach((altli) => {
//           const sizeValDiv = altli.querySelector('.size-val');
          
//           if (sizeValDiv) {
//               const sizeValue = sizeValDiv.textContent.trim(); // Get the value of the size

//               if (sizeMap.has(sizeValue)) {
//                   // If the size value already exists, hide this duplicate
//                   altli.style.display = 'none';
//               } else {
//                   // If the size value is unique, add it to the map
//                   sizeMap.set(sizeValue, altli);
//                   altli.style.display = 'block'; // Ensure the unique size is displayed
//               }
//           }
//       });
//   });
// }

// // Call the function to remove duplicate sizes
// removeDuplicateSizes();


// document.addEventListener("DOMContentLoaded", function() {
//     var endlessScroll = new Ajaxinate({
//       container: '#Huratips-Loop',
//       pagination: '#Huratips-Pagination',
//      callback: function() {
//                hideAltliWithoutHiddenInput();
//                 document.querySelectorAll('.product-grid-options-size .altli').forEach(div => {
//                   // Check if the div does NOT have both "is-selected" and "ava" classes
//                   if (!div.classList.contains('is-selected')) {
//                     // Hide the div if it doesn't have both classes
//                     div.style.display = 'none';
//                   }
//                 });
//                   const parentDiv = document.querySelector('.product-group-variants');

// // Attach event listeners to color radio buttons for each .product-group-variants
// document.querySelectorAll('.product-group-variants').forEach((productGroup) => {
//     const colorRadios = productGroup.querySelectorAll('.product-grid-options-color input[type="radio"]');
//     colorRadios.forEach((radio) => {
//         radio.addEventListener('change', updateSelectedSize);
//     });
// });

// // Initial state update for all .product-group-variants
// document.querySelectorAll('.product-group-variants').forEach((productGroup) => {
//     const selectedRadio = productGroup.querySelector('.product-grid-options-color input[type="radio"]:checked');
//     if (selectedRadio) {
//         updateSelectedSize({ target: selectedRadio });
//     }
// });

// removeDuplicateSizes();

// }
//     });
// });


// //search code below
// console.log("Javascript Called Here");

//   const searchInput = document.querySelector('.header-search__input');
//   let typingTimer; // Timer identifier
//   const typingDelay = 3000; // Delay time in milliseconds (e.g., 500ms)

//   // Add keyup event listener
//   searchInput.addEventListener('keyup', () => {
//     clearTimeout(typingTimer); // Clear the timer if the user is still typing
//     typingTimer = setTimeout(() => {
//       console.log('hello'); // Log "hello" when the user stops typing
//        hideAltliWithoutHiddenInput();
//        removeDuplicateSizes();

//      document.querySelectorAll('.product-group-variants').forEach((productGroup) => {
//      const colorRadios = productGroup.querySelectorAll('.product-grid-options-color input[type="radio"]');
//      colorRadios.forEach((radio) => {
//         radio.addEventListener('change', updateSelectedSize);
//     });
// });

// // Initial state update for all .product-group-variants
//    document.querySelectorAll('.product-group-variants').forEach((productGroup) => {
//     const selectedRadio = productGroup.querySelector('.product-grid-options-color input[type="radio"]:checked');
//     if (selectedRadio) {
//         updateSelectedSize({ target: selectedRadio });
//     }
// });

//  document.querySelectorAll('.product-grid-options-size .altli').forEach(div => {
//     // Check if the div does NOT have both "is-selected" and "ava" classes
//     if (!div.classList.contains('is-selected')) {
//       // Hide the div if it doesn't have both classes
//       div.style.display = 'none';
//     }
//   });
  
//     const parentDiv = document.querySelector('.product-group-variants');
      
//     }, typingDelay);
//   });

/* PLATIN: exact in-stock size facets + counts for collections and search --------
   This is the incremental search extension for the already-installed exact-counts V2.
   Goal:
   - preserve the existing collection behavior
   - support full storefront search pages as well
   - use real variant inventory (inventory_quantity > 0)
   - keep only model-relevant sizes for specific model searches such as "Arahi"
   - hide search cards that do not carry the selected size in stock
   - replace native size/result counts with exact unique-product counts
   - keep the customer-facing URL clean and never redirect
----------------------------------------------------------------------------- */
(function () {
  "use strict";

  var STOCK_SECTION_ID = "platin-stock-sizes";
  var CACHE_TTL_MS = 90 * 1000;
  var stockCache = new Map();
  var activeRequest = null;
  var refreshToken = 0;

  function normalize(value) {
    return String(value == null ? "" : value).trim().toLocaleLowerCase();
  }

  function getStockContextSection() {
    var marker = document.querySelector("[data-platin-collection], [data-platin-search]");
    return marker ? marker.closest(".shopify-section") : null;
  }

  function isSearchContext(root) {
    return Boolean(root && root.querySelector("[data-platin-search]"));
  }

  function getSizeFacets(root) {
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll("[data-platin-size-facet]"));
  }

  function getSizeParam(root) {
    var facet = getSizeFacets(root)[0];
    return facet ? facet.getAttribute("data-platin-size-param") || "" : "";
  }

  function getSelectedSizeValues(root) {
    var selected = new Set();

    getSizeFacets(root).forEach(function (facet) {
      facet.querySelectorAll('input[type="checkbox"]:checked').forEach(function (input) {
        var value = normalize(input.value);
        if (value) selected.add(value);
      });
    });

    return selected;
  }

  function setSizeFacetsLoading(root, loading) {
    getSizeFacets(root).forEach(function (facet) {
      facet.toggleAttribute("data-platin-stock-loading", Boolean(loading));

      facet.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
        if (input.checked) return;

        if (loading) {
          input.disabled = true;
          input.setAttribute("data-platin-stock-pending", "true");
        } else if (input.hasAttribute("data-platin-stock-pending")) {
          input.disabled = false;
          input.removeAttribute("data-platin-stock-pending");
        }
      });
    });
  }

  function buildStockUrl(sizeParam) {
    var url = new URL(window.location.href);

    // Count all sizes under every other active customer filter. The currently
    // selected size is removed so multi-select size counts remain useful.
    if (sizeParam) {
      url.searchParams.delete(sizeParam);
    }

    // The helper checks variant inventory itself. Do not rely on Shopify's
    // availability filter for the authoritative size-to-inventory relationship.
    url.searchParams.delete("filter.v.availability");
    url.searchParams.delete("page");
    url.searchParams.delete("section_id");
    url.searchParams.delete("sort_by");
    url.searchParams.set("section_id", STOCK_SECTION_ID);

    return url;
  }

  function stockCacheKey(url) {
    var key = new URL(url.toString());
    key.searchParams.delete("page");
    return key.pathname + "?" + key.searchParams.toString();
  }

  async function fetchStockPage(url, signal) {
    var response = await fetch(url.toString(), {
      method: "GET",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      cache: "no-store",
      signal: signal
    });

    if (!response.ok) {
      throw new Error("Stock size section request failed: " + response.status);
    }

    var html = await response.text();
    var doc = new DOMParser().parseFromString(html, "text/html");
    var payload = doc.querySelector("[data-platin-stock-sizes-json]");
    var wrapper = doc.querySelector("[data-platin-stock-sizes-response]");

    if (!payload) {
      throw new Error("Stock size section returned no JSON payload");
    }

    var entries;

    try {
      entries = JSON.parse(payload.textContent || "[]");
    } catch (error) {
      throw new Error("Stock size JSON parse failed: " + error.message);
    }

    if (!Array.isArray(entries)) {
      throw new Error("Stock size payload is not an array");
    }

    entries = entries.filter(function (entry) {
      return entry && typeof entry === "object" && entry.p != null && entry.s != null;
    });

    var nextUrl = null;

    if (wrapper) {
      var next = wrapper.getAttribute("data-platin-stock-sizes-next");

      if (next) {
        nextUrl = new URL(next, window.location.origin);
        nextUrl.searchParams.set("section_id", STOCK_SECTION_ID);
      }
    }

    return { entries: entries, nextUrl: nextUrl };
  }

  function addProductToSizeMap(map, size, productKey) {
    if (!map.has(size)) {
      map.set(size, new Set());
    }

    map.get(size).add(productKey);
  }

  function addHandleToSizeMap(map, size, handle) {
    if (!handle) return;

    if (!map.has(size)) {
      map.set(size, new Set());
    }

    map.get(size).add(handle);
  }

  function addStockEntry(stockData, entry) {
    var size = normalize(entry.s);
    var productKey = String(entry.p == null ? "" : entry.p);
    var handle = normalize(entry.h);

    if (!productKey) return;

    // Exact-model scope must still activate when the matched model is sold out.
    // Such products can arrive as marker rows with an empty size value.
    if (entry.m === true) {
      stockData.exactModelProductIds.add(productKey);
    }

    if (!size) return;

    addProductToSizeMap(stockData.productsBySize, size, productKey);
    addHandleToSizeMap(stockData.handlesBySize, size, handle);

    if (entry.m === true) {
      addProductToSizeMap(stockData.exactModelProductsBySize, size, productKey);
      addHandleToSizeMap(stockData.exactModelHandlesBySize, size, handle);
    }
  }

  async function fetchAllStockData(baseUrl, signal) {
    var cacheKey = stockCacheKey(baseUrl);
    var cached = stockCache.get(cacheKey);

    if (cached && Date.now() - cached.savedAt < CACHE_TTL_MS) {
      return cached.data;
    }

    var stockData = {
      productsBySize: new Map(),
      handlesBySize: new Map(),
      exactModelProductsBySize: new Map(),
      exactModelHandlesBySize: new Map(),
      exactModelProductIds: new Set(),
      hasExactModelScope: false
    };

    var nextUrl = baseUrl;
    var pageGuard = 0;

    while (nextUrl && pageGuard < 50) {
      pageGuard += 1;
      var page = await fetchStockPage(nextUrl, signal);

      page.entries.forEach(function (entry) {
        addStockEntry(stockData, entry);
      });

      nextUrl = page.nextUrl;
    }

    stockData.hasExactModelScope = stockData.exactModelProductIds.size > 0;
    stockCache.set(cacheKey, { savedAt: Date.now(), data: stockData });

    return stockData;
  }

  function readSizeLabelMetadata(control) {
    var label = control ? control.querySelector("label") : null;
    if (!label) return null;

    var baseLabel = label.getAttribute("data-platin-size-base-label");
    var hasCountAttribute = label.getAttribute("data-platin-size-has-count");

    if (baseLabel == null || hasCountAttribute == null) {
      var currentText = String(label.textContent || "").trim();
      var match = currentText.match(/^(.*?)(?:\s*\(([\d.,]+)\))\s*$/);
      var hasNativeCount = Boolean(match);

      baseLabel = hasNativeCount ? String(match[1] || "").trim() : currentText;
      label.setAttribute("data-platin-size-base-label", baseLabel);
      label.setAttribute("data-platin-size-has-count", hasNativeCount ? "true" : "false");

      return {
        label: label,
        baseLabel: baseLabel,
        hasNativeCount: hasNativeCount
      };
    }

    return {
      label: label,
      baseLabel: baseLabel,
      hasNativeCount: hasCountAttribute === "true"
    };
  }

  function updateSizeLabelCount(control, count) {
    var metadata = readSizeLabelMetadata(control);
    if (!metadata || !metadata.hasNativeCount) return;

    metadata.label.textContent = metadata.baseLabel + " (" + String(count) + ")";
    metadata.label.setAttribute("data-platin-exact-stock-count", String(count));
  }

  function unionSelectedValues(map, selectedSizes) {
    if (!selectedSizes.size) return null;

    var result = new Set();

    selectedSizes.forEach(function (size) {
      var values = map.get(size);
      if (!values) return;

      values.forEach(function (value) {
        result.add(String(value));
      });
    });

    return result;
  }

  function formatCount(count) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined).format(count);
    } catch (error) {
      return String(count);
    }
  }

  function updateProductCount(root, exactCount) {
    if (exactCount == null || !root) return;

    root.querySelectorAll(".collection-toolbar__products-count, [data-platin-products-count]").forEach(function (element) {
      var template = element.getAttribute("data-platin-products-count-template");

      if (!template) {
        var currentText = String(element.textContent || "").trim();
        var nativeCount = element.getAttribute("data-platin-native-products-count");
        var matchedText = "";
        var matchIndex = -1;

        if (nativeCount != null && nativeCount !== "") {
          var numericNativeCount = Number(nativeCount);
          var formattedNativeCount = Number.isFinite(numericNativeCount)
            ? formatCount(numericNativeCount)
            : nativeCount;

          matchIndex = currentText.indexOf(formattedNativeCount);
          matchedText = formattedNativeCount;

          if (matchIndex < 0 && formattedNativeCount !== nativeCount) {
            matchIndex = currentText.indexOf(nativeCount);
            matchedText = nativeCount;
          }
        }

        if (matchIndex < 0) {
          var numericMatch = currentText.match(/\d[\d.,]*/);
          if (!numericMatch || numericMatch.index == null) return;
          matchIndex = numericMatch.index;
          matchedText = numericMatch[0];
        }

        template = currentText.slice(0, matchIndex) +
          "__PLATIN_COUNT__" +
          currentText.slice(matchIndex + matchedText.length);

        element.setAttribute("data-platin-products-count-template", template);
      }

      element.textContent = template.replace("__PLATIN_COUNT__", formatCount(exactCount));
      element.setAttribute("data-platin-exact-stock-count", String(exactCount));
    });
  }

  function cardProductId(card) {
    return String(card && card.getAttribute("data-platin-product-id") || "");
  }

  function cardHandle(card) {
    if (!card) return "";

    return normalize(
      card.getAttribute("handle") ||
      card.getAttribute("data-platin-product-handle") ||
      card.getAttribute("data-limoniapps-discountninja-product-handle")
    );
  }

  function applyExactProductVisibility(root, selectedSizes, productsBySize, handlesBySize) {
    if (!root) return;

    var cards = root.querySelectorAll("product-card");

    if (!selectedSizes.size) {
      cards.forEach(function (card) {
        if (card.hasAttribute("data-platin-client-stock-hidden")) {
          card.hidden = false;
          card.style.removeProperty("display");
          card.removeAttribute("data-platin-client-stock-hidden");
        }
      });
      return;
    }

    var allowedProductIds = unionSelectedValues(productsBySize, selectedSizes) || new Set();
    var allowedHandles = unionSelectedValues(handlesBySize, selectedSizes) || new Set();

    cards.forEach(function (card) {
      var productId = cardProductId(card);
      var handle = cardHandle(card);
      var shouldShow = productId
        ? allowedProductIds.has(productId)
        : Boolean(handle && allowedHandles.has(handle));

      if (shouldShow) {
        if (card.hasAttribute("data-platin-client-stock-hidden")) {
          card.hidden = false;
          card.style.removeProperty("display");
          card.removeAttribute("data-platin-client-stock-hidden");
        }
      } else {
        card.hidden = true;
        card.style.setProperty("display", "none", "important");
        card.setAttribute("data-platin-client-stock-hidden", "true");
      }
    });
  }

  function toggleExactEmptyState(root, selectedSizes, exactCount) {
    if (!root) return;

    var exactEmpty = selectedSizes.size > 0 && exactCount === 0;

    root.querySelectorAll("[data-platin-exact-stock-empty]").forEach(function (element) {
      element.hidden = !exactEmpty;
    });

    root.querySelectorAll("[data-platin-product-list], .pagination").forEach(function (element) {
      element.hidden = exactEmpty;
    });
  }

  function relevantStockMaps(root, stockData) {
    var useExactModelScope = isSearchContext(root) && stockData.hasExactModelScope;

    if (useExactModelScope) {
      root.setAttribute("data-platin-size-scope", "exact-model");
      return {
        productsBySize: stockData.exactModelProductsBySize,
        handlesBySize: stockData.exactModelHandlesBySize
      };
    }

    root.removeAttribute("data-platin-size-scope");
    return {
      productsBySize: stockData.productsBySize,
      handlesBySize: stockData.handlesBySize
    };
  }

  function applyStockData(root, stockData) {
    var relevantMaps = relevantStockMaps(root, stockData);
    var productsBySize = relevantMaps.productsBySize;
    var handlesBySize = relevantMaps.handlesBySize;
    var selectedSizes = getSelectedSizeValues(root);

    getSizeFacets(root).forEach(function (facet) {
      facet.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
        var control = input.closest(".checkbox-control");
        if (!control) return;

        var value = normalize(input.value);
        var matchingProducts = productsBySize.get(value);
        var exactCount = matchingProducts ? matchingProducts.size : 0;
        var isAvailable = exactCount > 0;

        updateSizeLabelCount(control, exactCount);
        control.setAttribute("data-platin-exact-stock-count", String(exactCount));

        // An active value remains visible and clickable so the customer can remove it.
        if (input.checked) {
          control.hidden = false;
          input.disabled = false;
          input.removeAttribute("aria-disabled");
          input.removeAttribute("data-platin-stock-pending");
          return;
        }

        control.hidden = !isAvailable;
        input.disabled = !isAvailable;
        input.toggleAttribute("aria-disabled", !isAvailable);
        input.removeAttribute("data-platin-stock-pending");
      });

      facet.removeAttribute("data-platin-stock-loading");
      facet.setAttribute("data-platin-stock-ready", "true");
    });

    var matchingProductIds = unionSelectedValues(productsBySize, selectedSizes);
    var exactCount = matchingProductIds == null ? null : matchingProductIds.size;

    if (isSearchContext(root)) {
      applyExactProductVisibility(root, selectedSizes, productsBySize, handlesBySize);
      toggleExactEmptyState(root, selectedSizes, exactCount);
    }

    updateProductCount(root, exactCount);
  }

  async function refreshStockData(root) {
    root = root || getStockContextSection();
    if (!root) return;

    var sizeParam = getSizeParam(root);
    if (!sizeParam) return;

    var token = ++refreshToken;

    if (activeRequest) {
      try { activeRequest.abort(); } catch (error) {}
    }

    activeRequest = new AbortController();
    setSizeFacetsLoading(root, true);

    try {
      var stockData = await fetchAllStockData(buildStockUrl(sizeParam), activeRequest.signal);
      if (token !== refreshToken) return;

      var currentRoot = getStockContextSection();
      if (!currentRoot) return;

      applyStockData(currentRoot, stockData);
    } catch (error) {
      if (error && error.name === "AbortError") return;

      // Fail open: if the helper request fails, keep Shopify's native filters usable.
      console.warn("Platin exact stock-size filter failed:", error);
      var currentRoot = getStockContextSection();
      if (currentRoot) setSizeFacetsLoading(currentRoot, false);
    }
  }

  function boot() {
    var root = getStockContextSection();
    if (!root) return;

    var initialRefreshStarted = false;
    var idleRequestId = null;
    var fallbackTimer = null;

    function startInitialRefresh() {
      if (initialRefreshStarted) return;
      initialRefreshStarted = true;

      root.removeEventListener("pointerdown", onEarlyFacetIntent, true);
      root.removeEventListener("focusin", onEarlyFacetIntent, true);

      if (idleRequestId != null && "cancelIdleCallback" in window) {
        try { window.cancelIdleCallback(idleRequestId); } catch (error) {}
      }

      if (fallbackTimer != null) {
        window.clearTimeout(fallbackTimer);
      }

      refreshStockData(getStockContextSection());
    }

    function onEarlyFacetIntent(event) {
      var target = event.target;
      if (!target || !target.closest) return;

      if (target.closest('[data-platin-size-facet], [aria-controls="facets-drawer"]')) {
        startInitialRefresh();
      }
    }

    // Preserve the already-installed V2 behavior on collections. On search pages,
    // defer the helper until idle unless a size is already active, so search LCP is
    // not delayed while still having the data ready before/when the filter is used.
    if (!isSearchContext(root) || getSelectedSizeValues(root).size > 0) {
      startInitialRefresh();
    } else {
      root.addEventListener("pointerdown", onEarlyFacetIntent, true);
      root.addEventListener("focusin", onEarlyFacetIntent, true);

      if ("requestIdleCallback" in window) {
        idleRequestId = window.requestIdleCallback(startInitialRefresh, { timeout: 1200 });
      } else {
        fallbackTimer = window.setTimeout(startInitialRefresh, 450);
      }
    }

    // Shopify replaces the direct children of the same section after each facet update.
    var observer = new MutationObserver(function (mutations) {
      var replaced = mutations.some(function (mutation) {
        return mutation.type === "childList" && (mutation.addedNodes.length || mutation.removedNodes.length);
      });

      if (replaced) {
        window.requestAnimationFrame(function () {
          refreshStockData(getStockContextSection());
        });
      }
    });

    observer.observe(root, { childList: true, subtree: false });

    window.addEventListener("pageshow", function () {
      window.requestAnimationFrame(function () {
        refreshStockData(getStockContextSection());
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();

/* Product card mobile swiper — loaded once globally (moved from product-card.liquid) */
(function() {
    if (window.__platinProductCardMobileSwiperGuard) {
      return;
    }

    window.__platinProductCardMobileSwiperGuard = true;

    var startX = 0;
    var startY = 0;
    var moved = false;
    var activeLink = null;

    document.addEventListener('touchstart', function(event) {
      var link = event.target.closest && event.target.closest('.product-card__media--has-mobile-swiper');

      if (!link) {
        activeLink = null;
        return;
      }

      activeLink = link;
      moved = false;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });

    document.addEventListener('touchmove', function(event) {
      if (!activeLink || !event.touches || !event.touches.length) {
        return;
      }

      var diffX = Math.abs(event.touches[0].clientX - startX);
      var diffY = Math.abs(event.touches[0].clientY - startY);

      if (diffX > 10 && diffX > diffY) {
        moved = true;
      }
    }, { passive: true });

    document.addEventListener('click', function(event) {
      var link = event.target.closest && event.target.closest('.product-card__media--has-mobile-swiper');

      if (!link) {
        return;
      }

      if (moved) {
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }
    }, true);
  })();

  (function() {
    if (window.__platinNativeSwiperIndicatorGuard) {
      return;
    }

    window.__platinNativeSwiperIndicatorGuard = true;

    function getNormalizedProgress(swiper) {
      var maxScroll = swiper.scrollWidth - swiper.clientWidth;

      if (maxScroll <= 1) {
        return 0;
      }

      var rawScroll = swiper.scrollLeft;
      var currentScroll = rawScroll < 0 ? Math.abs(rawScroll) : rawScroll;

      currentScroll = Math.max(0, Math.min(currentScroll, maxScroll));

      return currentScroll / maxScroll;
    }

    function syncIndicator(swiper) {
      if (!swiper) return;

      var media = swiper.closest('.product-card__media--has-mobile-swiper');
      if (!media) return;

      var indicator = media.querySelector('.product-card__mobile-swiper-indicator');
      var thumb = media.querySelector('.product-card__mobile-swiper-indicator-thumb');

      if (!indicator || !thumb) return;

      var slides = swiper.querySelectorAll('.product-card__mobile-swiper-slide');
      var slideCount = slides.length;

      if (slideCount <= 1) {
        indicator.hidden = true;
        return;
      }

      indicator.hidden = false;

      var progress = getNormalizedProgress(swiper);
      var minFill = 100 / slideCount;
      var fillPercent = minFill + ((100 - minFill) * progress);

      fillPercent = Math.max(minFill, Math.min(100, fillPercent));

      thumb.style.width = fillPercent + '%';
      thumb.style.transform = 'none';
    }

    function setup(root) {
      root = root && root.querySelectorAll ? root : document;

      root.querySelectorAll('.product-card__mobile-swiper').forEach(function(swiper) {
        if (swiper.dataset.platinNativeIndicatorReady === 'true') {
          syncIndicator(swiper);
          return;
        }

        swiper.dataset.platinNativeIndicatorReady = 'true';

        swiper.addEventListener('scroll', function() {
          window.requestAnimationFrame(function() {
            syncIndicator(swiper);
          });
        }, { passive: true });

        syncIndicator(swiper);
      });
    }

    document.addEventListener('DOMContentLoaded', function() {
      setup(document);
    });

    window.addEventListener('load', function() {
      setup(document);
    });

    window.addEventListener('pageshow', function() {
      setup(document);
    });

    if (window.MutationObserver) {
      new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              setup(node);
            }
          });
        });
      }).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  })();